import React from 'react'
import { Input } from 'reactstrap'

export const ColumnFilter = ({ column }) => {
    const { filterValue, setFilter } = column
    return (
        <Input type="text" value={filterValue || ""} onChange={(e) => setFilter(e.target.value)} />
    )
}
